import { useQuery } from '@tanstack/react-query'
import { useActions } from '../../store'
import { useErrorHandler } from '../useErrorHandler'
import { useResponseHandler } from '../useResponseHandler'
import { useAffiliation, useAuth } from '../index'

const { env } = window

const useAdminCategories = () => {
  const { securedFetch } = useAuth()
  const { handleError } = useErrorHandler()
  const { handleResponse } = useResponseHandler()
  const { progressStart, progressEnd } = useActions()
  const { affiliation } = useAffiliation()

  const getAdminCategories = async (affiliationId) => {
    const url = encodeURI(
      `${env.apiUrl}/affiliations/${affiliationId}/categories`
    )
    const response = await securedFetch(url)
    await handleResponse(response)
    return response.json()
  }

  const query = useQuery({
    queryKey: ['admin-categories', affiliation?.id],
    queryFn: () => getAdminCategories(affiliation?.id),
    enabled: !!affiliation
  })

  if (query.isLoading) {
    progressStart()
  } else if (query.isSuccess) {
    progressEnd()
  } else if (query.isError) {
    handleError(query.error, 'Error getting groups')
    progressEnd()
  }

  return {
    categories: query.data
  }
}

export { useAdminCategories }
